// require all files in dir
const context = require.context('./', true, /\.(png|jpg|jpeg|gif|svg)$/)
context.keys().forEach(context)